// extracted by mini-css-extract-plugin
export default {"root":"_1rhq3","transform":"_3dfZ6","swipeable":"dlo4T","preview":"_25er_","next":"_8METt","prev":"_2epeQ"};